import { WireTypes } from "@flakiness/server/common/wireTypes.js";
import { html } from "lit";
import { markdown } from "../markdown.js";
import "./fk-runner-picker.js";
import { welcome_bun } from "./welcome_bun.js";
import { welcome_cucumberjs } from "./welcome_cucumberjs.js";
import { welcome_custom } from "./welcome_custom.js";
import { welcome_jest } from "./welcome_jest.js";
import { welcome_junit } from "./welcome_junit.js";
import { welcome_playwright } from "./welcome_playwright.js";
import { welcome_pytest } from "./welcome_pytest.js";
import { welcome_rust } from "./welcome_rust.js";
import { welcome_vitest } from "./welcome_vitest.js";

export const accessToken = (project: WireTypes.Project) => html`<sl-tag data-testid=flakiness-access-token>${project.readWriteAccessToken}</sl-tag><sl-copy-button value="${project.readWriteAccessToken}"></sl-copy-button>`;

export const welcome_new_project = (project: WireTypes.Project) => markdown`

### Welcome to your new project!

To upload reports, choose your test runner:

${html`
  <fk-runner-picker>
    <div slot="playwright">${welcome_playwright(project)}</div>
    <div slot="pytest">${welcome_pytest(project)}</div>
    <div slot="vitest">${welcome_vitest(project)}</div>
    <div slot="jest">${welcome_jest(project)}</div>
    <div slot="cucumberjs">${welcome_cucumberjs(project)}</div>
    <div slot="bun">${welcome_bun(project)}</div>
    <div slot="rust">${welcome_rust(project)}</div>
    <div slot="junit">${welcome_junit(project)}</div>
    <div slot="custom">${welcome_custom()}</div>
  </fk-runner-picker>
`}
`;
